import * as types from "@/store/types";

const state = {
  accountsList: []
};

const getters = {
  [types.corporate.getters.GET_ACCOUNTS_LIST]: state => {
    return state.accountsList;
  },
  [types.corporate.getters.GET_ACCOUNT_BY_UUID]: state => uuid => {
    return state.accountsList.find(item => item.uuid === uuid);
  }
};

const mutations = {
  [types.corporate.mutations.MUTATE_ACCOUNTS_LIST]: (state, payload) => {
    state.accountsList = payload;
  }
};

const actions = {
  [types.corporate.actions.SET_ACCOUNTS_LIST]: ({ commit }, payload) => {
    commit(types.corporate.mutations.MUTATE_ACCOUNTS_LIST, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
